<template>
  <v-container>
    <v-row>
      <v-col>
        <CalculationEditor
          :component="component"
          :containers="containers"
          :table="table"
          v-model="value.source"
          title="Value Expression"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <FieldValuePickerBase
          v-model="value.targetName"
          title="Target Name"
          :component="component"
          :containers="containers"
          :table="table"
          :model-only="true"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FieldValuePickerBase from "../shared/FieldValuePickerBase.vue";
import CalculationEditor from "../shared/CalculationEditor.vue";

export default {
  name: "SetModelDesigner",

  components: {
    FieldValuePickerBase,
    CalculationEditor,
  },

  props: ["value", "containers", "table", "component"],
};
</script>
